<template>
  <el-dialog
    :visible.sync="dialogVisible"
    center
    :close-on-click-modal="false"
    :before-close="handleClose"
    id="periodic"
    width="1065px"
  >
    <div slot="title" class="dialog_title">
      <div class="title_content">
      <div>您已选择:共 <span :style="{color: '#06D4B8'}">{{activeList.length}}</span> 个元素，至少选择 <span :style="{color: 'red'}">1</span> 个元素<span v-if="maxElement">，最多选择 <span :style="{color: 'red'}">{{ maxElement }}</span> 个元素</span> </div>
        <div><el-button @click="submitHandle()" type="primary"  style="border-radius: 20px" >确 认</el-button></div>
      </div>
    </div>
    <PeriodicTableOfElements @updateActive="updateActive" ref="periodic"></PeriodicTableOfElements>
  </el-dialog>
</template>
<script>
import PeriodicTableOfElements from "./index";
export default {
  components: { PeriodicTableOfElements },
  data() {
    return {
      dialogVisible: false,
      activeList: [],
      groupIndex: null,
      fiedIndex: null,
      isGobal: false,
      maxElement : null,
    };
  },
  methods: {
      init (items,index,indexs) {
        // 判断fieIdValue是否有值
          this.dialogVisible = true
          // this.isActiveInfo = isActiveInfo
          this.$nextTick(()=> {
            this.groupIndex = index
            this.fiedIndex = indexs
            this.maxElement = items.maxElement
            if(indexs === undefined || indexs == null){
              this.isGobal = true
            }
            if (this.$refs.periodic) {
              this.$refs.periodic.init(items)
            }
          })
      },
      handleClose () {
          this.dialogVisible = false
      },
      updateActive (list) {
        let activeList = list.filter(i=> {
          return i.isChoose
        })
        this.activeList = activeList
      },
      submitHandle () {
        if(!this.maxElement) {
          this.dialogVisible = false
          this.$emit('updateActive',this.activeList,this.groupIndex,this.fiedIndex,this.isGobal)
          return
        }
        if (this.activeList.length != 0) {
          if(this.activeList.length <= this.maxElement) {
            this.dialogVisible = false
            this.$emit('updateActive',this.activeList,this.groupIndex,this.fiedIndex,this.isGobal)
          } else {
            return this.$message.warning(`最多只能选择${this.maxElement}个元素`);
          }
        } else {
          return this.$message.warning("至少选择1个元素");
        }
      },
  }
};
</script>
<style scoped>
.dialog_title {
  width: 95%;
  margin-left: 10px;
}
.title_content {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  font-size: 16px;
}
</style>
<style>
#periodic .el-dialog__body{
  padding: 5px 30px 30px;
}
</style>